import { createFileRoute } from "@tanstack/react-router";

import { ConsolePeople } from "../features/console/account";

/** `subject` is optional, so every Link to this route may omit search entirely. */
export const Route = createFileRoute("/console/people")({
  validateSearch: (search: Record<string, unknown>): { subject?: string } => {
    const subject = search["subject"];
    return typeof subject === "string" && subject !== "" ? { subject } : {};
  },
  component: ConsolePeople,
});
